import styled, { css } from "styled-components";
import {
  Root as PrimitiveRoot,
  Indicator as PrimitiveIndicator,
} from "@radix-ui/react-checkbox";
import { CheckboxSize, RootProps } from "./checkbox";

export const sizeVariants: Record<CheckboxSize, number> = {
  sm: 16,
  md: 20,
};

export const BaseRoot = styled(PrimitiveRoot)<RootProps>`
  display: flex;
  width: ${({ size }) => sizeVariants[size || "md"]}px;
  height: ${({ size }) => sizeVariants[size || "md"]}px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 4px;

  &[data-state="unchecked"] {
    border: 1px solid ${({ theme }) => theme.colors.neutral[50]};

    &:hover:not(:disabled) {
      border: 2px solid ${({ theme }) => theme.colors.neutral[30]};
    }

    ${({ theme, hasError }) =>
      hasError &&
      css`
        border: 2px solid ${theme.colors.feedback.error[40]};
      `}

    &:disabled {
      border-color: ${({ theme }) => theme.colors.neutral[80]};
      background-color: ${({ theme }) => theme.colors.neutral[95]};
    }
  }

  &[data-state="checked"] {
    background-color: ${({ theme }) => theme.colors.secondary[50]};

    &:hover:not(:disabled) {
      background-color: ${({ theme }) => theme.colors.secondary[80]};
    }

    ${({ theme, hasError }) =>
      hasError &&
      css`
        background-color: ${theme.colors.feedback.error[40]};
      `}

    &:disabled {
      background-color: ${({ theme }) => theme.colors.neutral[80]};
    }
  }

  &:disabled {
    cursor: auto;
  }
`;

export const BaseIndicator = styled(PrimitiveIndicator)``;
